import React, { useEffect, useState } from 'react'
import { onlyNumber } from '../../../constants/validate'
import { ChevronDown } from 'react-feather'

import Spinner from '../../Spinner'

import './index.scss'

const Select = ({ value = "", label = "Sample", options = [{ value: "sample", label: "Sample" }], required = false, error = false, disabled = false, isLoading = false, onBlur = () => { }, onChange = (value = "") => { }, onPressEnter = () => { }, style }) => {
  const [isFocus, setIsFocus] = useState(false)
  const [hasError, setHasError] = useState(error)
  const [hasValue, setHasValue] = useState(false)

  useEffect(() => setHasError(error), [error])

  function handleOnBlur() {
    setIsFocus(false)
    onBlur && onBlur()
  }

  function handleOnChange(evt) {
    const value = evt.target.value
    onChange && onChange(value)
    setHasError(error)
  }

  function handlePressEnter(evt) {
    if (evt.key === 'Enter') onPressEnter && onPressEnter()
  }

  function returnLabelClassName() {
    let currentClassName = "select__label"
    if (isFocus || hasValue || value) currentClassName += " select__label--open"
    if (isFocus) currentClassName += " select__label--focus"
    return currentClassName
  }

  function returnSelectClassName() {
    let currentClassName = "select"
    if (!value) currentClassName += " select--empty"
    return currentClassName
  }

  function returnClassName() {
    let currentClassName = "select__wrapper"
    if (hasError) currentClassName += " select__wrapper--error"
    if (disabled) currentClassName += " select__wrapper--disabled"
    return currentClassName
  }

  return (
    <div className={returnClassName()}>
      <span className={returnLabelClassName()}>{label}{required && " *"}</span>
      <select
        className={returnSelectClassName()}
        value={value}
        style={{ style }}
        onMouseDown={() => setIsFocus(true)}
        onClick={() => setIsFocus(true)}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        onKeyPress={handlePressEnter}
        onAnimationStart={e => e.animationName === "onAutoFillStart" ? setHasValue(true) : setHasValue(false)}
        required={required}
        onInvalid={() => setHasError(true)}
      >
        <option disabled hidden></option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>{option.label}</option>
        ))}
      </select>
      {isLoading ? (
        <div className='select__wrapper-spinner'>
          <Spinner size={16}/>
        </div>
      ) : (
        ''
      )}
      
    </div>
  )
}

export default Select
